import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Markets from './pages/Markets';
import News from './pages/News';
import Calendar from './pages/Calendar';
import Alerts from './pages/Alerts';
import Settings from './pages/Settings';
import DataQualityMonitor from './components/DataQualityMonitor';
import { useAppStore } from './store';
import { cn } from './utils';

// Placeholder components for other pages







const App: React.FC = () => {
  const { theme } = useAppStore();
  const [showDataMonitor, setShowDataMonitor] = useState(false);

  return (
    <div className={cn("min-h-screen", theme === 'dark' ? 'dark' : '')}>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/markets" element={<Markets />} />

            <Route path="/news" element={<News />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </Layout>
      </Router>
      
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: 'rgba(15, 15, 35, 0.9)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#e2e8f0',
            backdropFilter: 'blur(12px)'
          }
        }}
      />
      
      <DataQualityMonitor 
        isVisible={showDataMonitor}
        onToggle={() => setShowDataMonitor(!showDataMonitor)}
      />
    </div>
  );
};

export default App;